import React , {useState, useEffect} from 'react';
import {MenuHeader} from "./MenuHeader"

export function Menu ({items, Page, checkMenuChange}) {
  const [menuItems, setMenuItems] = useState(items) ;
  const [page] = useState(Page) ;

  useEffect(()=>{
    if(items !== null && items !== menuItems){
      setMenuItems(items)
    }
  }, [items, menuItems])

  return (
    <>
      {
        menuItems.map((item, index) =>(
          <MenuHeader  key={"MenuHeader"+item.menuId} item={item} Page={page} title ={item.menuName} checkMenuChange={checkMenuChange} />
        ))
      }
    </>
  )

}